import styled from 'styled-components';
import PencilIcon from 'js/components/core/Icons/PencilIcon';

export default styled(PencilIcon)`
  width: 100%;
  height: 1rem;
  text-align: center;
`;
